import usePassengerInformationFormStep1 from '../../../../../viewModels/flights/passenger.information.form.step1.viewModel';
import '../../styles.css';

function Step1({
  savePNR,
  userDetail,
  location,
  dataToEdit,
}) {


  const {
    listOfForms,
    openList,
    setopenList,
    currentPassenger,
    setCurrentPassenger,
    validarCampos,
    isBtnPrevious,
    isBtnNext,
    selectCurrentPassenger,
    buildData,
    inputsList,
    refSelectList,
    getInputError,

  } = usePassengerInformationFormStep1(
    savePNR,
    userDetail,
    location,
    dataToEdit,
    );

  const endFormAndCompletd = validarCampos(listOfForms[currentPassenger]) && currentPassenger === listOfForms.length - 1;


  return (
    <div className='pifsStepContainer'>

      <div className='pifsStepContainerHeader'>
        {
          listOfForms?.length > 0 && listOfForms.map((index, key) => {
            const limit = listOfForms?.length;
            const number = key + 1;
            const isActive = key === currentPassenger;
            const isFull = validarCampos(listOfForms[key]);
            return (
              <div key={key} className='numberAndLine'>
                <div className={`headerStep ${isActive ? 'headerStepFocus' : ''}`}
                //  onClick={() => isFull && setCurrentPassenger(key)}
                 >
                  <div className={`headerStepNumber ${isFull ? 'headerStepNumberOn' : 'headerStepNumberOff'}`}>
                    <p className='headerStepNumberText'>{number}</p>
                  </div>
                  <p className='headerStepName'>{index?.key}</p>
                </div>
                {number < limit &&
                  <div className='pifsStepContainerHeaderSeparator' />
                }
              </div>
            )
          })
        }
      </div>

      <div className='pifsFormHead'>
        <p className='pifsFormHeadTitle'>
          Datos de {listOfForms[currentPassenger]?.key}.</p>
        <p className='pifsFormHeadSubTitle'>
          Ingrese el nombre y apellido tal como aparecen en el pasaporte o documento de identidad de cada pasajero
        </p>
        <p className='pifsFormHeadSubTitle'>
          Campos marcados con (*) son obligatorios.
        </p>
      </div>

      <div className='pifsFormBody'>
        {
          inputsList.map((index, key) => {
            const isError = getInputError(index);
            return (
              <div className='pifsFormBodyInputs' key={key}>
                <p className='pifsFormBodyInputsTitle'><b>{index.required && '* '}</b>{index?.title}</p>
                <p className='pifsFormBodyInputsLabel'>{index?.label}</p>
                <div className='pifsFormBodyInputsLabelContainer'
                  onClick={() => index?.type === 'select' && setopenList(!openList)}
                >
                  <input
                    id={index?.id}
                    type={index?.type}
                    value={index?.value}
                    placeholder={index?.placeHolder}
                    onChange={index?.func}
                    name={index?.name}
                    className='pifsFormBodyInputsLabelContainerInput'
                    autoComplete="off"
                  />
                </div>
                {openList && index?.type === 'select' &&
                  <div className='pifsFormBodyInputsSelectList' ref={refSelectList}>
                    {index?.optionsList.map((child, key) => {
                      return (
                        <div key={key} onClick={() => [index?.func(child, index?.id), setopenList(!openList)]}
                          className='pifsFormBodyInputsSelectListOpt'>
                          <p className='pifsFormBodyInputsSelectListOptText'>{child}</p>
                        </div>
                      )
                    })}
                  </div>}
                {
                  isError && <p className='pifsFormBodyInputsError'>{isError?.message}</p>
                }
              </div>
            )
          })
        }
      </div>

      <div className='pifsFormFoot'>
        <div className={`pifsFormFootBtn ${isBtnPrevious ? 'pifsFormFootBtnOn' : 'pifsFormFootBtnOff'}`}
          onClick={() => isBtnPrevious && selectCurrentPassenger(-1)}
        >
          <p className='pifsFormFootBtnText'>Anterior</p>
        </div>
        {endFormAndCompletd ?
          <div className={`pifsFormFootBtn ${isBtnNext ? 'pifsFormFootBtnOn' : 'pifsFormFootBtnOff'}`}
            onClick={() => isBtnNext && buildData()}>
            <p className='pifsFormFootBtnText'>Finalizar</p>
          </div>
          :
          <div className={`pifsFormFootBtn ${isBtnNext ? 'pifsFormFootBtnOn' : 'pifsFormFootBtnOff'}`}
            onClick={() => isBtnNext && selectCurrentPassenger(+1)}>
            <p className='pifsFormFootBtnText'>Siguiente</p>
          </div>
        }
      </div>
    </div>
  )
}

export default Step1;